import { useTranslation } from 'react-i18next';
import { useTypedParams } from 'react-router-typesafe-routes';
import GroupAdminSelectList from '@/components/groups/group-admin-sectioned-list/group-admin-select-list';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import useGroupInfo from '@/hooks/groups/use-group-info';
import ROUTES from '@/routes';

export default function AddGroupAdminRoute() {
  const { t } = useTranslation();
  const { id: groupId } = useTypedParams(ROUTES.MESSAGES.GROUPS);
  const { canManage } = useGroupInfo(groupId);

  return (
    <PageLayout
      title={t('conversation.setting.group.admin.add-admin')}
      className='w-full'
      headerConfig={{
        navigateBack: true,
      }}>
      {canManage && <GroupAdminSelectList groupId={groupId} />}
    </PageLayout>
  );
}
